export function safeJsonParse<T>(str: string): T | null {
  try {
    const jsonValue = JSON.parse(str) as T;

    return jsonValue;
  } catch (error) {
    console.error("Failed to parse JSON:", error);
    return null;
  }
}
